import React from "react";
import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <path d="M9.5,15.23l8.59-8.58a1,1,0,0,1,1.41,0h0a1,1,0,0,1,0,1.41l-9.29,9.29a1,1,0,0,1-1.42,0L4.5,13.06a1,1,0,0,1,0-1.41h0a1,1,0,0,1,1.41,0Z" />,
  "GuardianCheckMark"
);
